import { Box } from '@mui/material';
import React from 'react';
export const VolunteersAdminTableSurface = ({ children }) => (React.createElement(Box, { sx: { backgroundColor: 'transparent' } }, children));
